import React from 'react';
import Header from '../components/Header';
import HeroCarousel from '../components/HeroCarousel';
import NewsSection from '../components/NewsSection';
import FeaturedProjects from '../components/FeaturedProjects';
import PhilosophySection from '../components/PhilosophySection';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <HeroCarousel />
        <NewsSection />
        <FeaturedProjects />
        <PhilosophySection />
      </main>
      <Footer />
    </div>
  );
};

export default Home;